<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <router-link to="/crDesignated">
            <div class="btn btn-default btn-table-title">新增特約</div>
          </router-link>
        </div>
        <br>
        <div class="form-group" v-if="brandBrief.length > 1">
          <select class="form-control h-38" v-model="brandSelect">
            <option v-for="brand in brandBrief" :value="brand.value">
              {{brand.label}}
            </option>
          </select>
        </div>
        <div class="form-group" v-if="brandSelect !== 0 && brandSelect !== '0' && storeBrief.length > 1 && $route.name !== 'storeInfo'">
          <select class="form-control h-38" v-model="storeSelect">
            <option :value="0">== 門市 ==</option>
            <option v-for="store in storeBrief" :value="store.value">
              {{store.label}}
            </option>
          </select>
        </div>
        <!-- 公司型態 -->
        <div class="form-group">
          <select class="form-control h-38" v-model="typeSelect">
            <option v-for="type in typeList" :value="type.value">
              {{type.label}}
            </option>
          </select>
        </div>
        <!-- 擁有者 -->
        <div class="form-group text-left">
          <select class="form-control h-38" v-model="ownerSelect">
            <option v-for="owner in ownerList" :value="owner.value">
              {{owner.label}}
            </option>
          </select>
        </div>
        <br>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchSelect">
            <option value="1">單位名稱</option>
            <option value="2">廠區名稱</option>
          </select>
        </div>
        <div class="form-group input-group time-box" v-if="searchSelect == 1">
          <div class="input-group">
            <input class="form-control" type="text" v-model="unit">
            <span class="input-group-addon c-pointer" @click="search(1)"><i class="fa fa-search"></i></span>
          </div>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 2">
          <div class="input-group">
            <input class="form-control" type="text" v-model="branch">
            <span class="input-group-addon c-pointer" @click="search(2)"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">特約單位 (ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">廠區名稱</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99">品牌(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99 || roleType === 30">分店(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">擁有者</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">統一編號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
          </tr>
          </thead>
          <tbody v-if="designatedList">
          <tr class="even" role="row" v-for="(designated, index) in designatedList">
            <td class="sorting_1">{{index + 1}}</td>
            <td>{{designated.unit}} ({{designated.id}})</td>
            <td>{{designated.branch}}</td>
            <td v-if="roleType === 99">{{designated.brand_name}}({{designated.brand_id}})</td>
            <td v-if="roleType === 99 || roleType === 30">
              <span v-if="designated.store_id">{{designated.store_name}}({{designated.store_id}})</span>
              <span v-else>全部</span>
            </td>
            <td>
              {{ownerName(designated.owner)}}
            </td>
            <td>{{designated.ein}}</td>
            <td>{{getTime(designated.create_time)}}</td>
            <td>
              <router-link :to="'/upDesignated/' + designated.brand_id + '/' + designated.id">
                <button class="btn btn-default">
                  <i class="fa fa-pencil"></i>
                </button>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!--
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
      >
      </paginate>
      -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
export default{
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: '',
      total: 1,
      count: 20,
      designatedList: [],
      shopperId: 0,
      unit: '',
      branch: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: 0,
      storeSelect: 0,
      typeSelect: 0,
      ownerSelect: 0,
      deTypeSelect: 999,
      isCreatedTime: false,
      isCreatedStore: false,
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      typeList: [
        {label: '== 公司型態 ==', value: 0},
        {label: '民營企業', value: 1},
        {label: '公家機關', value: 2},
        {label: '企業內部規劃', value: 3}
      ],
      ownerList: [
        {label: '== 擁有者 ==', value: 0},
        {label: '平台', value: 3},
        {label: '品牌', value: 1},
        {label: '門市', value: 2}
      ]
    }
  },
  methods: {
    ownerName (owner) {
      switch (owner) {
        case 1: return '品牌'
        case 2: return '門市'
        case 3:
        default:
          return '平台'
      }
    },
    search (method) {
      if (method === 1 && this.unit) {
        this.getDesignatedList(1)
      } else if (method === 2 && this.branch) {
        this.getDesignatedList(1)
      } else this.getDesignatedList()
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    labelColor (type) {
      if (type === 1) {
        return 'label-default'
      } else if (type === 707 || type === 701) {
        return 'label-success'
      } else if (type === 709) {
        return 'label-danger'
      } else if (type === 710) {
        return 'label-info'
      }
    },
    stateColor (state) {
      if (state === 11) {
        return 'label-default'
      } else if (state === 12) {
        return 'label-primary'
      } else if (state === 13) {
        return 'label-success'
      } else if (state === 21) {
        return 'label-danger'
      } else if (state === 22) {
        return 'label-danger'
      }
    },
    tradeType (type) {
      if (type === 1) {
        return '現金'
      } else if (type === 707) {
        return 'LINE PAY'
      } else if (type === 701) {
        return 'iPASS MONEY'
      } else if (type === 709) {
        return '信用卡(台新)'
      } else if (type === 710) {
        return '信用卡'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '未付款'
      } else if (state === 12) {
        return '付款中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderStateColor (state) {
      switch (state) {
        case 140: // 已作廢
        case 120: // 被店家退訂
        case 121: // 被系統退訂
        case 122: // 已取消
        case 99: // 使用者取消訂單
          return 'label-danger'
        case 100: // 未接單
          return 'label-default'
        case 110: // 已接單
          return 'label-primary'
        case 130: // 已完成
          return 'label-success'
        default:
          return 'label-warning'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '客人取消'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '店家退訂'
      } else if (state === 121) {
        return '系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    shippingStateColor (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三方取消(分派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'text-danger'
        case 0: // 叫件開案
          return 'text-default'
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確定叫件
        case 110: // 未分派司機
        case 120: // 第三方已分派外送員
        case 130: // 司機已取貨,開始送貨
          return 'text-primary'
        case 140: // 司機已送達
          return 'text-success'
        default:
          return ''
      }
    },
    shippingStateColorBg  (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三方取消(分派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'bg-danger'
        case 0: // 叫件開案
          return 'bg-default'
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確定叫件
        case 110: // 未分派司機
        case 120: // 第三方已分派外送員
        case 130: // 司機已取貨,開始送貨
          return 'bg-primary'
        case 140: // 司機已送達
          return 'bg-success'
        default:
          return ''
      }
    },
    shippingState (state) {
      if (state === 0) {
        return '叫件開案'
      } else if (state === 10) {
        return '已報價'
      } else if (state === 19) {
        return '報價失敗'
      } else if (state === 50) {
        return '叫件中'
      } else if (state === 59) {
        return '叫件失敗'
      } else if (state === 100) {
        return '成立物流單'
      } else if (state === 110) {
        return '物流接單'
      } else if (state === 120) {
        return '已分派外送員'
      } else if (state === 130) {
        return '已取貨'
      } else if (state === 140) {
        return '已送達'
      } else if (state === 900 || state === 901 || state === 910 || state === 921 || state === 930 || state === 940) {
        return '門市取消叫件'
      } else if (state === 920) {
        return '媒合失敗'
      }
    },
    selectStyle (item) {
      var self = this
      this.$nextTick(function () {
        this.designatedList.forEach(function (item) {
          self.$set(item, 'active', false)
        })
        this.$set(item, 'active', true)
      })
    },
    outStyle (item) {
      this.$set(item, 'active', false)
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getDesignatedList()
    },
    getDesignatedList (page) {
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var self = this
      var url = '/brand/' + this.brandSelect + '/designatedUnit/list?'
      if (this.storeSelect) url = url + '&store_id=' + this.storeSelect
      if (this.ownerSelect) url = url + '&owner=' + this.ownerSelect
      if (this.typeSelect) url = url + '&type=' + this.typeSelect
      if (this.searchSelect === 1 && this.unit) url = url + '&unit=' + this.unit
      if (this.searchSelect === 2 && this.branch) url = url + '&branch=' + this.branch
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.designatedList = response.data.list
            // self.total = response.data.total
          }
        })
      }
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj.value
            // else if (i === 0 && bList.length === 1) self.brandSelect = obj.value
          }
          self.getDesignatedList()
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (!self.isCreatedStore) {
              self.isCreatedStore = true
            } else if (i === 0) {
              // if (self.getRoleType === '10' || self.getRoleType === 10) self.storeSelect = obj.value
              self.getDesignatedList(1)
            }
          }
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    checkMemberShow (status) {
      if (this.roleType === 30) {
        if (status === 130 || status === 140) return true
        else return false
      } else return true
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm')
    }
  },
  created () {
    this.getBrandBrief()
    this.roleType = parseInt(this.getRoleType, 10)
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    brandSelect () {
      this.storeSelect = 0
      if (this.$route.name === 'storeInfo') {
        this.storeSelect = this.$route.params.store_id
        this.getStoreBrief(this.brandSelect)
      } if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect)
      } else {
        this.getDesignatedList(1)
      }
      window.sessionStorage.setItem('Nidin_orderTable_brandS', this.brandSelect)
    },
    storeSelect () {
      this.getDesignatedList(1)
      window.sessionStorage.setItem('Nidin_orderTable_storeS', this.storeSelect)
    },
    typeSelect () {
      this.getDesignatedList(1)
    },
    ownerSelect () {
      this.getDesignatedList(1)
    }
  }
}
</script>
<style lang="sass">
.shipping-state-label
  position: absolute
  width: max-content
  padding: 5px
  border-radius: 6px
  z-index: 30
  font-size: 12px
  font-weight: 600
  top: -30px
  left: -18px
.text-del
  text-decoration: line-through
.bg-pre-order
  background: #FBF4E6 !important
.active.btn-all, .active.btn-basic, .active.btn-gb
  opacity: 0.4
.p-10
 padding: 10px !important
.time-box
  max-width: 236px
  #start-box, #end-box
    width: auto
  #start-box input
    border-radius: 3px 0px 0px 0px !important
  #end-box input
    border-radius: 0px 0px 0px 3px !important
@media screen and (max-width: 768px)
  .time-box
    max-width: calc( 100vw - 20px)
@media screen and (max-width: 768px)
 .time-box .cov-vue-date .cov-datepicker
    width: calc(100vw - 90px)
</style>



// WEBPACK FOOTER //
// DesignatedTableTemp.vue?80b04a3e